module.exports = __webpack_public_path__ + "img/4-1.d7418543.svg";